import { getAnalytics, logEvent } from "firebase/analytics";

export default function({store}) {
    if(window.location.origin !== "https://eventos.639app.com") return;
    const analytics = getAnalytics();

    if (!store.$router.history.pending) {
      window.location.href = `${process.env.VUE_APP_BASE_URL_EVENT_FRONT}`
      return;
    }

    const path = store.$router.history.pending.path.split("/")
    const screen = `${path.length === 2 ? path[1] : path[1] === 'rtm' ? path[2] : path[1]}/${path.length === 2 ? "Lp" : path[1] === "rtm" ? "Cadastro" : path[2]}`;
    const screenClass = path.length === 2 ? path[1] : path[1] === 'rtm' ? path[2] : path[1];

    logEvent(analytics, 'screen_view', {
        firebase_screen: screen,
        firebase_screen_class: screenClass
    });
}
